import { Container } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import {
    StyledFooter,
    Copyright,
    FooterNavRow,
    FooterNavCol,
    StyledFooterInner,
    SocialLinks,
    StyledFooterBottom
} from './styles/Footer.styled'
import moment from 'moment'

interface Item {
    title: string
    links: NavLink[]
}

interface NavLink {
    name: string
    url: string
    cnOnly?: boolean
}

const Footer = () => {
    const { t } = useTranslation()


    return (
        <StyledFooter>
            <Container>
                <StyledFooterInner>
                    <FooterNavRow>
                        <FooterNavCol><img src="/images/logo-footer.png" alt="" /></FooterNavCol>
                        <div style={{
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'flex-end'
                        }}>
                            <Copyright>
                                ©{moment().format('YYYY')} Shop Business Power<br />
                                Shop Business Power is not affiliated with any government agency or utility company.<br />
                            </Copyright>
                        </div>
                    </FooterNavRow>
                </StyledFooterInner>
                <StyledFooterBottom>
                </StyledFooterBottom>
            </Container>
        </StyledFooter>
    )
}

export default Footer
